import React, { type FunctionComponent } from 'react'
import {
  Button,
  Section,
  SectionContent,
  SectionSeparator,
  spacing,
} from '@retailer-platform/shared-components'
import { useFieldArray, type Control, type FormContextValues } from 'react-hook-form'
import { css } from '@emotion/react'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { CollectionsRule } from 'domains/collections/components/collections-form/components/rules/CollectionsRule'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'

interface CollectionsRulesProps {
  control: Control<CollectionsFormData>
  register: FormContextValues<CollectionsFormData>['register']
  watch: FormContextValues<CollectionsFormData>['watch']
  retailerId: string
  errors: FormContextValues<CollectionsFormData>['errors']
}

export const CollectionsRules: FunctionComponent<CollectionsRulesProps> = ({
  control,
  register,
  watch,
  retailerId,
  errors,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'rules',
  })

  const messages = useDomainMessages({
    title: 'collectionsDomain.collectionsForm.section.rules',
    addNewRule: 'collectionsDomain.collectionsForm.section.rules.action.addNewRule',
  })

  return (
    <Section
      headerElement={
        <Button variant="secondary" onClick={() => append({})}>
          {messages.addNewRule}
        </Button>
      }
      title={messages.title}
      wrapperStyles={css({
        marginTop: spacing.X32,
      })}
    >
      {fields.map(({ id }, index) => (
        <React.Fragment key={id}>
          <SectionContent>
            <CollectionsRule
              watch={watch}
              control={control}
              register={register}
              formPrefix={`rules[${index}]`}
              deleteRule={() => remove(index)}
              retailerId={retailerId}
              errors={errors}
            />
          </SectionContent>
          <SectionSeparator />
        </React.Fragment>
      ))}
    </Section>
  )
}
